const userAgent = navigator.userAgent.toLowerCase();
/** 判断是否苹果客户端 */
const isAndroid = /Android/i.test(userAgent);
const isiPhone = /iPhone/i.test(userAgent);
const isiPad = /iPad/i.test(userAgent);
const isOpenHarmony = /OpenHarmony/i.test(navigator.userAgent.toLowerCase());
export const getSystemName = () => {
	if (isAndroid || isOpenHarmony) {
		return 'Android';
	} else if (isiPhone) {
		return 'iPhone';
	} else if (isiPad) {
		return 'iPad';
	} else {
		return '';
	}
};

export const getBrowserVersion = type => {
	const agent = navigator.userAgent.toLowerCase();
	const regStr_ie = /msie [\d.]+;/gi;
	const regStr_ff = /firefox\/[\d.]+/gi;
	const regStr_chrome = /chrome\/[\d.]+/gi;
	const regStr_saf = /safari\/[\d.]+/gi;
	const regStr_wexin = /MicroMessenger\/([\d\.]+)/gi;

	const regMap = {
		Ie: regStr_ie,
		Firefox: regStr_ff,
		Chrome: regStr_chrome,
		Safari: regStr_saf,
		Wexin: regStr_wexin
	};
	const browser = agent.match(regMap[type]);
	return (browser + '').replace(/[^0-9.]/gi, '');
};

export const getBrowserInfo = () => {
	const agent = navigator.userAgent.toLowerCase();
	let browser = '';
	let version = '';
	const isChrome = agent.indexOf('chrome') > 0 || agent.indexOf('crios') > 0;

	// wechat
	if (agent.indexOf('micromessenger') > 0) {
		browser = 'Wexin';
		version = getBrowserVersion(browser);
		return {
			browser,
			version
		};
	}

	// IE
	if (agent.indexOf('msie') > 0) {
		browser = 'Ie';
		version = getBrowserVersion(browser);
		return {
			browser,
			version
		};
	}

	//firefox
	if (agent.indexOf('firefox') > 0) {
		browser = 'Firefox';
		version = getBrowserVersion(browser);
		return {
			browser,
			version
		};
	}

	//Safari
	if (agent.indexOf('safari') > 0 && !isChrome) {
		browser = 'Safari';
		version = getBrowserVersion(browser);
		return {
			browser,
			version
		};
	}

	//Chrome
	if (isChrome) {
		browser = 'Chrome';
		version = getBrowserVersion(browser);
		return {
			browser,
			version
		};
	}

	return {
		browser,
		version
	};
};

export const getDeviceName = () => {
	return getBrowserInfo().browser;
};
